import React from 'react';
import { getFirstOption, FocusActionType } from './';
const setFocus = (focusState = {}) => {
    return Object.assign({ searchFocus: false, optionFocus: null, actionFocus: null, filterFocus: false, triggerFocus: false }, focusState);
};
export const focusReducer = (state, action) => {
    switch (action.type) {
        case FocusActionType.SetFocus: {
            return setFocus(Object.assign({}, action.payload));
        }
        default:
            return setFocus();
    }
};
export const getInitialState = (search, header, options, preventFocus, tree) => {
    const searchExists = !!search || !!(header === null || header === void 0 ? void 0 : header.search);
    const firstOption = options ? getFirstOption(options, tree) : null;
    if (preventFocus) {
        return {
            searchFocus: false,
            optionFocus: null,
            actionFocus: null,
            filterFocus: false,
            triggerFocus: false,
        };
    }
    return {
        searchFocus: searchExists,
        optionFocus: searchExists || !options ? null : firstOption,
        actionFocus: null,
        filterFocus: false,
        triggerFocus: !searchExists && !firstOption,
    };
};
export const FocusContext = React.createContext(null);
//# sourceMappingURL=FocusContext.js.map